import React, { useState } from "react";
import Modal from "react-modal";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { jsPDF } from "jspdf";
import Utility from "../../utility";
// import html2pdf from "html2pdf.js";
import html2canvas from "html2canvas";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Itemmanager from "../../context/Itemmanager";
import Garnishmanager from "../../context/Garnishmanager";
import Floatmanager from "../../context/Floatmanager";
import Prepmanager from "../../context/Prepmanager";
Modal.setAppElement("#root");

const SendEmailPopup = ({
  visible,
  onClose,
  onCancel,
  onSend,
  onSendMailTrigger,
  selectedrecipes = null,
  slectedRecipients = null,
}) => {
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [loading, setloading] = React.useState(false);
  // console.log("selectedrecipes", selectedrecipes);
  // console.log("slectedRecipients", slectedRecipients);
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      padding: "20px",
      border: "none",
      borderRadius: "15px",
      width: "90%",
      maxWidth: "400px",
      boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
      backgroundColor: "#fff",
    },
  };
  //   const generateRecipeHTML = (recipe) => {
  //     const itemsHTML = recipe.items
  //       .map(
  //         (i) =>
  //           `<tr>
  //             <td>${i.itemname || "-"}</td>
  //             <td>${i.unitName || "-"}</td>
  //             <td>${i.totalOunces || "-"}</td>
  //           </tr>`
  //       )
  //       .join("");

  //     return `
  //       <div style="font-family: Arial; padding: 16px;">
  //         <h2 style="text-align:center;">${recipe.craftname}</h2>
  //         <p><b>Shared By:</b> ${recipe.sharedBy || "N/A"}</p>
  //         ${
  //           recipe.imageUrl
  //             ? `<img src="${recipe.imageUrl}" style="width:100%;max-height:250px;object-fit:cover;border-radius:8px;" />`
  //             : ""
  //         }
  //         <h3>Ingredients</h3>
  //         <table border="1" cellspacing="0" cellpadding="6" style="width:100%;border-collapse:collapse;">
  //           <thead>
  //             <tr><th>Item</th><th>Unit</th><th>Total Ounces</th></tr>
  //           </thead>
  //           <tbody>${itemsHTML}</tbody>
  //         </table>
  //       </div>
  //     `;
  //   };

  //   const pdfContent = async (
  //     recipename,
  //     recipeimageurl,
  //     itemrender,
  //     dilutionrender,
  //     floatRender,
  //     garnishrender,
  //     glassware,
  //     glasswareArray,
  //     totalYields,
  //     totalBatchedOunces,
  //     totalOunces
  //   ) => {
  //     let imgurl =
  //       recipeimageurl && recipeimageurl.length > 0
  //         ? recipeimageurl
  //         : "https://firebasestorage.googleapis.com/v0/b/craftiqapp.appspot.com/o/backbar.png?alt=media&token=e76dfad4-5800-4a34-bfed-d937f098e516";

  //     let showItem = itemrender?.[0]?.itemname?.length > 0;
  //     let showDilution = dilutionrender?.[0]?.itemname?.length > 0;
  //     let showfloats = floatRender?.[0]?.itemname?.length > 0;
  //     let showgarnish = garnishrender?.[0]?.itemname?.length > 0;
  //     let showPrep = glassware?.length > 0 || glasswareArray?.[0]?.length > 0;

  //     let garray = (glasswareArray || []).filter((text) => text.length !== 0);

  //     console.log(" imgurl",  recipename,
  //       " recipeimageurl",  recipeimageurl,
  //      " itemrender",   itemrender,
  //      " dilutionrender",   dilutionrender,
  //      " floatRender",   floatRender,
  //      " garnishrender",   garnishrender,
  //      " glassware",   glassware,
  //     " glasswareArray",    glasswareArray,
  //     " totalYields",    totalYields,
  //         totalBatchedOunces,
  //         totalOunces );
  //     // console.log(" imgurl", imgurl, );

  //     return `<!DOCTYPE html>
  // <html>
  // <head>
  //   <style>
  //     @page {
  //       margin: 40px 40px 80px 40px;
  //     }
  //     body {
  //       font-family: 'Helvetica', sans-serif;
  //       font-size: 10px;
  //       background-color: #fdfaf4;
  //       color: #333;
  //     }
  //     header {
  //       top: -80px;
  //       left: 0;
  //       right: 0;
  //       height: 80px;
  //       color: #4B2E2E;
  //       display: flex;
  //       align-items: center;
  //       justify-content: space-between;
  //       padding: 0 20px;
  //     }
  //     footer {
  //       bottom: -60px;
  //       left: 0;
  //       right: 0;
  //       height: 50px;
  //       color: #4B2E2E;
  //       display: flex;
  //       align-items: center;
  //       justify-content: space-between;
  //       padding: 0 20px;
  //       font-size: 10px;
  //     }
  //     header img, footer img {
  //       height: 30px;
  //     }
  //     .page-number:after {
  //       content: counter(page);
  //     }
  //     .container {
  //       padding: 0 0;
  //     }
  //     .section-title {
  //       font-weight: bold;
  //       margin: 20px 0 5px;
  //       border-bottom: 2px solid #B8860B;
  //       color: #4B2E2E;
  //       font-size: 14px;
  //     }
  //     table {
  //       width: 100%;
  //       border-collapse: collapse;
  //       margin: 10px 0;
  //     }
  //     th, td {
  //       border: 1px solid #B8860B;
  //       padding: 6px;
  //       text-align: left;
  //     }
  //     th {
  //       background-color: #F5DEB3;
  //       color: #4B2E2E;
  //     }
  //     .image-container {
  //       text-align: center;
  //       margin-top:10px;
  //     }
  //     .image-container img {
  //       width: 200px;
  //       height: 200px
  //       object-fit: contain
  //       border: 2px solid #B8860B;
  //       border-radius: 5px;
  //     }
  //       .title-centered {
  //       text-align: center;
  //       margin-top: 0;
  //       color: #4B2E2E;
  //     }
  //   </style>
  // </head>
  // <body>
  //   <header>
  //     <img src="https://thecraftiq.com/wp-content/uploads/2022/05/logo.png" alt="CraftIQ Logo" />
  //     <div><strong>CraftIQ</strong> | <a href="https://thecraftiq.com" style="color: #4B2E2E; text-decoration: none;">thecraftiq.com</a></div>
  //     <div>${new Date().toLocaleDateString()}</div>
  //   </header>

  //   <div class="container">
  //     <h2 class="title-centered">${recipename}</h2>

  //     ${showItem ? `
  //     <div class="section-title">Items</div>
  //     <table>
  //       <tr><th>Item</th><th>Quantity</th><th>Unit</th><th>Total Ounce</th></tr>
  //       ${itemrender.map(line => `<tr><td>${line.itemname}</td><td>${line.Quantity}</td><td>${line.unitName}</td><td>${line.totalOunces.toFixed(3)}</td></tr>`).join('')}
  //     </table>` : ''}

  //     ${showDilution ? `
  //     <div class="section-title">Dilution</div>
  //     <table><tr><td>${dilutionrender[0].itemname}</td><td>${dilutionrender[0].totalOunces.toFixed(3)}</td></tr></table>` : ''}

  //     ${showfloats ? `
  //     <div class="section-title">Float / Muddle / Other</div>
  //     <table><tr><th>Item</th><th>Quantity</th><th>Unit</th><th>Total Ounce</th></tr>
  //       ${floatRender.map(line => `<tr><td>${line.itemname}</td><td>${line.Quantity}</td><td>${line.unitName}</td><td>${line.totalOunces.toFixed(3)}</td></tr>`).join('')}
  //     </table>` : ''}

  //     ${showgarnish ? `
  //     <div class="section-title">Garnish</div>
  //     <table><tr><th>Item</th><th>Quantity</th><th>Unit</th><th>Total Ounce</th></tr>
  //       ${garnishrender.map(line => `<tr><td>${line.itemname}</td><td>${line.Quantity}</td><td>${line.unitName}</td><td>${line.totalOunces.toFixed(3)}</td></tr>`).join('')}
  //     </table>` : ''}

  //     ${showPrep ? `
  //     <div class="section-title">Preparation</div>
  //     <table><tr><td>Glassware</td><td>${glassware}</td></tr>
  //       ${garray.map(text => `<tr><td colspan="2">${text}</td></tr>`).join('')}
  //     </table>` : ''}

  //     <div class="section-title">Summary</div>
  //     <table>
  //       <tr><th></th><th>Total Yield</th><th>Batched Ounces</th><th>Total Ounces</th></tr>
  //       <tr><td></td><td>${totalYields}</td><td>${totalBatchedOunces}</td><td>${totalOunces}</td></tr>
  //     </table>

  //     <div class="image-container">
  //       <img src=${imgurl} alt="Recipe Image" />
  //     </div>
  //   </div>
  //     <footer>
  //     <img src="https://thecraftiq.com/wp-content/uploads/2022/05/logo.png" alt="CraftIQ Logo" />
  //     <div>CraftIQ &copy; ${new Date().getFullYear()} | Page <span class="page-number"></span></div>
  //   </footer>
  // </body>
  // </html>`;

  // };

  var TotalYield = 0
  var TotalBatchedOunces = 0
  var TotalOunces = 0


  const generatePDF = async (recipes) => {


    //const doc = new jsPDF("p", "pt", "a4");
    var htmlpdfArray = []


    for (let i = 0; i < recipes.length; i++) {
      const recipe = recipes[i];

      let itemarry = [], dilutionarry = [], floatarry = [], garnisharry = [];

      for (const item of recipe.items) {

        let id = item.key
        switch (item.type) {
          case "item":
            itemarry.push(Itemmanager.getInstance().setItems(item, id));
            break;
          case "dilution":
            dilutionarry.push(Itemmanager.getInstance().setItems(item, id));
            break;
          case "garnish":
            garnisharry.push(Garnishmanager.getInstance().setItems(item, id));
            break;
          case "float":
            floatarry.push(Floatmanager.getInstance().setItems(item, id));
            break;
        }
      };

      const sortedItems = itemarry.sort((a, b) => a.order - b.order);
      const sortedDilution = dilutionarry.sort((a, b) => a.order - b.order);
      const sortedFloat = floatarry.sort((a, b) => a.order - b.order);
      const sortedGarnish = garnisharry.sort((a, b) => a.order - b.order);

      totalOunceYieldWithValue(sortedItems, sortedDilution, sortedFloat, sortedGarnish);

      const htmlString = await Utility.pdfContent(
        recipe.craftname,
        recipe.imageUrl || "",
        sortedItems,
        sortedDilution,
        sortedFloat,
        sortedGarnish,
        recipe.glassware || "",
        glasswareStringArrayToObject(recipe.glasswareDetails),
        TotalYield.toFixed(3),
        TotalBatchedOunces.toFixed(3),
        TotalOunces.toFixed(3)
      );

      htmlpdfArray.push(htmlString);


      // // Create temp div
      // const tempDiv = document.createElement("div");
      // tempDiv.innerHTML = htmlString;

      // document.body.appendChild(tempDiv);

      // // Convert HTML to image
      // const canvas = await html2canvas(tempDiv, {
      //   scale: 1,
      //   useCORS: true,
      //   logging: false,
      // });

      // const imgData = canvas.toDataURL("image/png");
      // const imgProps = doc.getImageProperties(imgData);

      // const pdfWidth = doc.internal.pageSize.getWidth();
      // const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

      // if (i > 0) doc.addPage();
      // doc.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);

      // document.body.removeChild(tempDiv);
    }

    // doc.save(subject || "All_Recipes.pdf");

    // const pdfBlob = doc.output("blob");
    // const pdfUrl = URL.createObjectURL(pdfBlob);


    return htmlpdfArray;
  };


  function totalOunceYieldWithValue(itemsArry, diluArry, floatRender, garnishrender) {
    var ounces = 0;
    var yields = 0;
    var TotalOunceWithDilution = 0
    itemsArry.forEach((item) => {
      if (item.itemname.length > 0) {
        ounces = ounces + item.totalOunces;
        yields = yields + item.yields;
      }
    });
    if (diluArry.length > 0) {
      let dilu = diluArry[0];
      let val = dilu.totalOunces + totalitemOunceValue(itemsArry);

      TotalOunceWithDilution = val;

      if (dilu.itemname.length > 0) {
        ounces = ounces + dilu.totalOunces;
        yields = yields + dilu.yields;
      }
    }

    if (ounces == 0 && yields == 0) {
      return;
    }
    TotalBatchedOunces = ounces;
    // setTotalOunces(yields);
    TotalYield = (ounces == 0 && yields == 0) ? 0 : Math.ceil(yields / ounces);
    var allOunces = ounces
    var allyields = yields
    floatRender.forEach((item) => {
      if (item.itemname.length > 0) {
        if (totalValueswithFloatGarnish(item.itemname, item.unitName, item.unitValue, item.totalOunces, TotalOunceWithDilution)) {
          allOunces = allOunces + item.totalOunces
          allyields = allyields + item.totalOunces
        }
      }
    });

    garnishrender.forEach((item) => {
      if (item.itemname.length > 0) {
        if (totalValueswithFloatGarnish(item.itemname, item.unitName, item.unitValue, item.totalOunces, TotalOunceWithDilution)) {
          allOunces = allOunces + item.totalOunces
          allyields = allyields + item.totalOunces
        }
      }
    });

    TotalOunces = allyields;

  }

  function totalitemOunceValue(itemsArry) {
    var total = 0;
    itemsArry.forEach((item) => {
      total = total + item.totalOunces;
    });
    return total;
  }

  function totalValueswithFloatGarnish(item, unitName, unit, value, totalWithDilution) {

    if (item == "Egg White" && unitName == "ea") {
      return true//(totalWithDilution + value)
    }
    else if (item == "Egg Yolk" && unitName == "ea") {
      return true//(totalWithDilution + value)
    }
    else if (item == "Whole Egg" && unitName == "ea") {
      return true//(totalWithDilution + value)
    }
    else if (unitName == "187ml" || unitName == "1.5 Liter" || unitName == "1.75 Liter" || unitName == "Liter" || unitName == "Table Spoon" || unitName == "Cup" || unitName == "Pint" || unitName == "375ml" || unitName == "750ml" || unitName == "Gallon" || unitName == "Quart" || unitName == "Ounce" || unitName == "Float" || unitName == "Rinse" || unitName == "Dash" || unitName == "Spritz" || unitName == "Drop" || unitName == "ml" || unitName == "2oz" || unitName == "Bar Spoon" || unitName == "3oz" || unitName == "5oz" || unitName == "6oz" || unitName == "8oz" || unitName == "9oz" || unitName == "10oz" || unitName == "12oz" || unitName == "11.2oz" || unitName == "16oz" || unitName == "24oz" || unitName == "Table Spoon" || unitName == "Tea Spoon" || unitName == "Splash") {
      return true//(totalWithDilution + value)
    }

    else {
      return false
    }
  }


  function glasswareStringArrayToObject(ary) {
    if (!ary) {
      return [""]
    }
    else {
      let prep = Prepmanager.getInstance();
      var arry = [""];

      ary.forEach((value) => {
        arry.push(value);
      });
      return arry
    }
  }
  // const generatePDF = async (recipes) => {
  //   const doc = new jsPDF("p", "pt", "a4");
  //   let firstPage = true;

  //   // for (const recipe of recipes) {
  //   //   if (!firstPage) doc.addPage();
  //   //   firstPage = false;
  //   //   const html = generateRecipeHTML(recipe);
  //   //   await doc.html(html, {
  //   //     x: 20,
  //   //     y: 20,
  //   //     html2canvas: { scale: 0.5 },
  //   //   });
  //   // }

  //   console.log("recipesddd", recipes);
  //   console.log(
  //     "recipesddd 75758766",
  //     recipes[0].craftname,
  //     recipes[0].imageUrl,
  //     recipes[0].items,
  //     recipes[0].dilutionrender || [],
  //     recipes[0].floatRender || [],
  //     recipes[0].garnishrender || [],
  //     recipes[0].glassware,
  //     recipes[0].glasswareArray || [],
  //     "totalYields",
  //     recipes[0].totalYields || "-",
  //     recipes[0].totalBatchedOunces || "-",
  //     recipes[0].totalOunces || "-"
  //   );

  //   const htmlString = await Utility.pdfContent(
  //     recipes[0].craftname,
  //     recipes[0].imageUrl,
  //     recipes[0].items,
  //     recipes[0].dilutionrender || [],
  //     recipes[0].floatRender || [],
  //     recipes[0].garnishrender || [],
  //     recipes[0].glassware,
  //     recipes[0].glasswareArray || [],
  //     recipes[0].totalYields || "-",
  //     recipes[0].totalBatchedOunces || "-",
  //     recipes[0].totalOunces || "-"
  //   );

  //   // // Open in a new browser tab
  //   //   const newWindow = window.open();
  //   //   newWindow.document.open();
  //   //   newWindow.document.write(htmlString);
  //   //   newWindow.document.close();

  //   // return htmlString;

  //   const opt = {
  //     margin: 0.5,
  //     filename: subject,
  //     image: { type: "jpeg", quality: 0.98 },
  //     html2canvas: { scale: 2 },
  //     jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
  //   };

  //   html2pdf().from(htmlString).set(opt).save();
  // };

  const handleSend = async () => {
    if (!subject) {
      // showAlert("CraftIQ", "Please provide subject")]
      alert("Please provide a subject");
      return;
    }

    if (!body) {
      alert("Please provide a body");
      return;
    }
    if (!selectedrecipes.length) {
      alert("No recipes to export");
      return;
    }
    setloading(true);
    try {
      const pdfUrl = await generatePDF(selectedrecipes);


      //   const link = document.createElement("a");
      //   link.href = pdfUrl;
      //   link.download = `${subject || "Recipes"}.pdf`;
      //   link.click();

      // Option 2: Trigger parent callback (e.g. email send)
      if (onSendMailTrigger) {
        const recipients = slectedRecipients.map((r) => r.email);

        onSendMailTrigger({ subject, body, recipients, pdfUrl });
      }

      setSubject("");
      setBody("");

    } catch (error) {
      console.warn("Error sharing:", error);
    } finally {
      setloading(false);
    }

    // if (onSend) {
    //   onSend({ subject, body });
    // }
    // setSubject("");
    // setBody("");
    // onClose();
  };

  return (
    <Modal
      isOpen={visible}
      onRequestClose={onClose}
      style={customStyles}
      contentLabel="Send Email Modal"
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <h3
          style={{
            textAlign: "center",
            marginBottom: 20,
            fontWeight: "600",
            color: "#000",
          }}
        >
          Add Subject <br /> and Body
        </h3>

        <TextField
          fullWidth
          label="Subject"
          variant="outlined"
          size="small"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
          style={{ marginBottom: 15 }}
        />

        <TextField
          fullWidth
          label="Body"
          variant="outlined"
          multiline
          minRows={4}
          value={body}
          onChange={(e) => setBody(e.target.value)}
          style={{ marginBottom: 20 }}
        />

        <Button
          variant="text"
          onClick={handleSend}
          style={{
            color: "#007AFF",
            fontWeight: "500",
            textTransform: "none",
            marginBottom: 10,
          }}
        >
          Send Email
        </Button>

        <Button
          variant="text"
          onClick={onClose}
          style={{
            color: "#007AFF",
            fontWeight: "500",
            textTransform: "none",
          }}
        >
          Cancel
        </Button>
      </div>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      // onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Modal>
  );
};

export default SendEmailPopup;
